import { useEffect } from 'react'
import { useAmpli } from 'src/hooks'
import { AppointmentProfile } from 'src/types'

export function useAppointmentEvents() {
    const {
        appointmentCardCtaClicked,
        navigatedToAppointmentsPage,
        filterAppointmentsByServiceLine,
        clickServiceLineModuleOnAppointmentsPage,
        showMoreOfTag
    } = useAmpli()

    function trackAppointmentCardCtaClicked(offering: AppointmentProfile) {
        appointmentCardCtaClicked(offering)
    }

    function trackServiceLineChange(serviceLines: string[]) {
        filterAppointmentsByServiceLine(serviceLines)
    }

    function trackServiceLineBannerClick(name: string) {
        clickServiceLineModuleOnAppointmentsPage(name)
    }

    function trackSeeMoreOptionsClicked(appointmentTagName: string) {
        showMoreOfTag(appointmentTagName)
    }

    useEffect(() => {
        navigatedToAppointmentsPage()
    }, [])

    return {
        trackAppointmentCardCtaClicked,
        trackServiceLineBannerClick,
        trackServiceLineChange,
        trackSeeMoreOptionsClicked
    }
}
